















































import Vue from 'vue';
import {
  Component, Prop,
} from 'vue-property-decorator';
import CycleValidationQualificationsTable from '@/components/rewardsvalidation/CycleValidationQualificationsTable.vue';
import CycleValidationRewardsTable from '@/components/rewardsvalidation/CycleValidationRewardsTable.vue';
import { ValidationProduct } from '@/api/rewardsvalidation';


@Component({
  components: {
    'qualification-table': CycleValidationQualificationsTable,
    'rewards-table': CycleValidationRewardsTable,
  },
})
export default class CycleValidationResultCard extends Vue {
  @Prop() validationResult!: ValidationProduct;

  @Prop({ default: false }) rewardsMachineLearningNotFound!: boolean;

  @Prop({ default: false }) qualsMachineLearningNotFound!: boolean;

  qualificationsExpanded: boolean = true;

  rewardsExpanded: boolean = true;
}
